import { Routes } from '@angular/router';
import { permissionGuard } from '../../../auth/guards/permission-guard';
import { Permission } from '../../../auth/interfaces/permission.pojo';
import { ROUTE_PATHS } from '../../../routing/routes.pojo';
import { ADMIN_ROUTE_PATHS } from './admin-routes.pojo';

export const ADMIN_ROUTES: Routes = [
  {
    path: `${ADMIN_ROUTE_PATHS.admin}`,
    loadComponent: () =>
      import('../admin-area/admin-area').then((c) => c.AdminArea),
    canActivate: [permissionGuard],
    data: {
      permission: Permission.ADMIN,
      redirectTo: ROUTE_PATHS.home,
    },
  },
];
